import { Injectable } from '@angular/core';
import { Subject } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class LoginStateService {

  private changeSource = new Subject<boolean>();
  private loginSource = new Subject<any>();
  private userInfoSource = new Subject<any>();
  public activeLabel!: string;
  public isVisits = false;
  public isWorkOrders = false;
  public workOrderId!: string | null;
  public workOrderNumber!: string | null;
  loginStateChanged$ = this.changeSource.asObservable();
  loginData$ = this.loginSource.asObservable();
  userInfoData$ = this.userInfoSource.asObservable();

  constructor() {
  }

  loginStateChanged(loginStateChanged: boolean) {
    this.changeSource.next(loginStateChanged);
  }
  getLoginData(data: any){
    this.loginSource.next(data);
  }
  getUserInfo(info: any){
    this.userInfoSource.next(info)
  }
}
